<template>
    <div class="input flex flex-wrap mb-4 md:w-1/2 pr-4">
      <div class="input__label">
        <label :for="CreatePropertyId(fieldLabel)" class="leading-relaxed text-xs lg:text-sm uppercase font-700">{{ $t(fieldLabel) }}</label>
      </div>
      <div class="input__field">
        <select :id="CreatePropertyId(fieldLabel)" v-model="selectedCountry">
            <option v-for="(c, index) of countries" :key="index" :value="c" :selected="c.code2 == selectedCountryCode">{{c.label}}</option>
        </select>
      </div>
    </div>
</template>

<script>
    import HtmlPropertyHelper from '@/mixins/HtmlPropertyHelper';
    import CaagApi from '@/mixins/CaagApi';

    export default {
        name: 'Countries',
        mixins: [HtmlPropertyHelper, CaagApi],
        props: {
            fieldLabel: String,
            currentCountryCode: String
        },
        data: () => ({
            countries: null,
            selectedCountry: null,
            errors: []
        }),
        computed: {
            selectedCountryCode: function() {
                if ( this.selectedCountry ) {
                    return this.selectedCountry.code2;
                }
                else {
                    return null;
                }
            }
        },
        mounted() {
            this.getCountries()
        },
        watch: {
            selectedCountry: function(val) {
                this.$emit('changeCountry', val);
            }
        },
        methods: {

        }
    }
</script>
